import React from "react";
import styled from "styled-components";
import { Route, Switch } from "react-router-dom";

import Header from "./components/Header";
import MainContent from "./components/Content";
import InfoPage from "./components/Info";
import QueryString from "query-string"

import MqttClient from "./modules/MqttClient"

const MainView = styled.div`
  background-image: url("/bakgrundblue_optimized.svg");
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  position: fixed;
  :before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    background: inherit;
    z-index: -1;
    transition: all 2s linear;
    -moz-transition: all 2s linear;
    -webkit-transition: all 2s linear;
    -o-transition: all 2s linear;
  }

  @media screen and (min-width: 400px) {
    min-height: 100%;
    width: 100%;
  }

@media screen and (max-width: 500px) {
  min-height: 100%;
  width: 100%;
}
`;

function App() {
  // ...?building=HHH&department=VV&room=RRRR&bed=SS
  var params = QueryString.parse(window.location.search);
  console.log(params);
  var alarmid = "1234" + "56" + "789" + "10";
  MqttClient.initialize(alarmid);
  MqttClient.connect();
  return (
    <>
      <MainView>
        <Header></Header>
        <Switch>
          <Route
            exact
            path="/"
            /*render={() => <MainContent/>}*/
            component={MainContent}
          />
        </Switch>
        <Route path="/info" render={() => <InfoPage />} />
      </MainView>
    </>
  );
}

export default App;
